import { useAppTheme } from "@hooks/useAppTheme";
import { ScrollView } from "react-native";
import { Dialog, IconButton, Portal } from "react-native-paper";
import { ProethicaPrinciplesExplorer } from "./ProethicaPrinciplesExplorer";
import { useProethicaPrinciples } from "./data";

type Props = {
	visible: boolean;
	handleClose: () => void;
};

export const ProethicaPrinciplesDialog = ({ visible, handleClose }: Props) => {
	const theme = useAppTheme();
	const principles = useProethicaPrinciples();

	return (
		<Portal>
			<Dialog
				visible={visible}
				onDismiss={handleClose}
				style={{
					alignSelf: "center",
					width: "92%",
					maxWidth: 600,
					maxHeight: "85%",
					backgroundColor: theme.colors.surface,
					overflow: "hidden",
				}}
			>
				<Dialog.ScrollArea
					style={{ paddingHorizontal: 0, borderColor: "transparent" }}
				>
					<ScrollView showsVerticalScrollIndicator={false}>
						<ProethicaPrinciplesExplorer
							principles={principles}
							headerAction={
								<IconButton
									icon="close"
									onPress={handleClose}
									accessibilityLabel="Close"
								/>
							}
						/>
					</ScrollView>
				</Dialog.ScrollArea>
			</Dialog>
		</Portal>
	);
};
